module.exports = __webpack_public_path__ + "img/M55CNCshow-2.d5064a66.jpg";